module.exports = __webpack_public_path__ + "static/Arhimar-cfb77fcea30599bce6f1bcf41f59ce09.jpg";